// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DiscountController from "./discount_controller"
application.register("discount", DiscountController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import QuantityInputController from "./quantity_input_controller"
application.register("quantity-input", QuantityInputController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
